export default __webpack_public_path__ + "static/media/BackupFile.eacc465a.svg";